/**
 * The kind of health plan a patient's insurance record describes. primary owns this vocabulary —
 * the insurance record stores it, constrained to these values in the database.
 */
export var InsurancePlanType;
(function (InsurancePlanType) {
    InsurancePlanType["Hmo"] = "HMO";
    InsurancePlanType["Ppo"] = "PPO";
    InsurancePlanType["Epo"] = "EPO";
    InsurancePlanType["Pos"] = "POS";
    InsurancePlanType["Hdhp"] = "HDHP";
    InsurancePlanType["Hsa"] = "HSA";
})(InsurancePlanType || (InsurancePlanType = {}));
//# sourceMappingURL=planType.js.map